import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import {
  Exceptiondt2hlxn7j7vw as Exception,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  weight31wqab1913ly4 as weight,
  textPopover3tarprbgmgxbr as textPopover,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  Companion_getInstance23x6zslwzj0st as Companion_getInstance_0,
  Align_End_getInstancer37lklmdzqms as Align_End_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import {
  priority2y7gf37j4tged as priority,
  cellView255m1dxiud5di as cellView,
  cellFormub3o1hqp20e5 as cellForm,
  labeledForm2ame2d0a5lql9 as labeledForm,
  labeledView3rpvir7z2o9ii as labeledView,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
import {
  _EmailAddress___get_raw__impl__6ose226bwkbm01ev3l as _EmailAddress___get_raw__impl__6ose2,
  toEmailAddress1e4w5ykg7qyos as toEmailAddress,
  EmailAddress1cvm8sbtoer9i as EmailAddress,
  _EmailAddress___get_url__impl__h7wdun30pft8c6nophf as _EmailAddress___get_url__impl__h7wdun,
  _PhoneNumber___get_raw__impl__gc2pmp2jq67zyqivc5w as _PhoneNumber___get_raw__impl__gc2pmp,
  toPhoneNumber2boyry1jrtl94 as toPhoneNumber,
  PhoneNumber16oapr4wkp1a5 as PhoneNumber,
  _PhoneNumber___get_url__impl__12igm01qncyrbzd7cb3 as _PhoneNumber___get_url__impl__12igm0,
} from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { errorText83fzxqvlxz6i as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { ExternalLink3fl954ixvn5zt as ExternalLink } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ExternalLink.commonHtml.mjs';
import {
  ExternalLink$_get_to_$ref_jqs3qa3v9hculrvd9um as ExternalLink$_get_to_$ref_jqs3qa,
  ExternalLink$_set_to_$ref_l7iod237nxghgvhqhbn as ExternalLink$_set_to_$ref_l7iod2,
} from './ServerFileRenderer.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ForcePaddingSemantic_getInstance2xrz1oepj1itn as ForcePaddingSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { NumberInput16nzuc28fuw7p as NumberInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/NumberField.commonHtml.mjs';
import {
  LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance,
  LabelSemantic_getInstance4iffxvo6ijig as LabelSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { text189ciz0cnr32o as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import {
  plus310ted5e4i90h as plus,
  first58ocm7j58k3q as first,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  _Area___get_acres__impl__gakf2d1zdhpqeurygsy as _Area___get_acres__impl__gakf2d,
  _Area___init__impl__ijsx701jgfgrev4lwyu as _Area___init__impl__ijsx70,
  Area3pv4op213wjp3 as Area,
  _Volume___get_liquidOunces__impl__d78jyr3uqefcew61vh7 as _Volume___get_liquidOunces__impl__d78jyr,
  _Volume___init__impl__tjrqop293xbbs3qjofv as _Volume___init__impl__tjrqop,
  Volumegj5eonccqlgm as Volume,
  _Volume___get_cups__impl__tqhzrxjta30zi8wv6u as _Volume___get_cups__impl__tqhzrx,
  _Volume___get_pints__impl__mv76881i3sc988qvcvg as _Volume___get_pints__impl__mv7688,
  _Volume___get_quarts__impl__2w1hjy2tq282b0j1g1z as _Volume___get_quarts__impl__2w1hjy,
  _Volume___get_gallons__impl__smxhou2tdf5455355yu as _Volume___get_gallons__impl__smxhou,
  _Volume___get_cubicFeet__impl__wre3ykxjitpvfo2ki5 as _Volume___get_cubicFeet__impl__wre3yk,
  _Mass___get_weightOunces__impl__w4i8hh1ic2p2iyma7r2 as _Mass___get_weightOunces__impl__w4i8hh,
  _Mass___init__impl__g55pzh1l06mgzajhizq as _Mass___init__impl__g55pzh,
  Massc7d9yuefyj4d as Mass,
  _Mass___get_pounds__impl__r7075nulkd9gbvtgb as _Mass___get_pounds__impl__r7075n,
  _Mass___get_tons__impl__so9xvw2ic7hyiso53t8 as _Mass___get_tons__impl__so9xvw,
  _Speed___get_feetPerSecond__impl__vx28ng12jmil5je79ti as _Speed___get_feetPerSecond__impl__vx28ng,
  _Speed___init__impl__580hla120ske4lxoqd4 as _Speed___init__impl__580hla,
  Speed3hiscdw6s9yl6 as Speed,
  _Speed___get_milesPerHour__impl__yxl3t010ih676g3jgak as _Speed___get_milesPerHour__impl__yxl3t0,
  _Acceleration___get_feetPerSecondPerSecond__impl__3tkghi1mb0ofbwrcml6 as _Acceleration___get_feetPerSecondPerSecond__impl__3tkghi,
  _Acceleration___init__impl__lpurpblc5vcql0b289 as _Acceleration___init__impl__lpurpb,
  Acceleration2sg6kr91atni2 as Acceleration,
  _Acceleration___get_milesPerHourPerSecond__impl__umq308epcbiadbsmt0 as _Acceleration___get_milesPerHourPerSecond__impl__umq308,
  _Force___get_newtons__impl__qua8gd1rlfdtz7of3hw as _Force___get_newtons__impl__qua8gd,
  _Force___init__impl__w7900e3gdp3n8t11y81 as _Force___init__impl__w7900e,
  Force2u0di6c6847v4 as Force,
  _Force___get_poundForce__impl__ne6ai41hzjkpddraa12 as _Force___get_poundForce__impl__ne6ai4,
  _Pressure___get_atmospheres__impl__m90i7k1wejul9q6e094 as _Pressure___get_atmospheres__impl__m90i7k,
  _Pressure___init__impl__4rek047cbbbitchry8 as _Pressure___init__impl__4rek04,
  Pressure2waumxspf1dhw as Pressure,
  _Pressure___get_psi__impl__877eh1bs5b88nrctez as _Pressure___get_psi__impl__877eh1,
  _Energy___get_joules__impl__q784q2ctvajuqmhi3f as _Energy___get_joules__impl__q784q,
  _Energy___init__impl__paow1l1qd7fp5jh2hhe as _Energy___init__impl__paow1l,
  Energy165sfuoiv695w as Energy,
  _Power___get_watts__impl__8v3onk1meh6yqi1q5xy as _Power___get_watts__impl__8v3onk,
  _Power___init__impl__y6lnpo30h3udcwtlqs7 as _Power___init__impl__y6lnpo,
  Power2nl309hjq9mej as Power,
  _Power___get_kilowatts__impl__xnqgmnibp5tyz5sz9v as _Power___get_kilowatts__impl__xnqgmn,
  _Temperature___get_celsius__impl__lhbsrwuf8reliep8e5 as _Temperature___get_celsius__impl__lhbsrw,
  _Temperature___init__impl__i36a2tw4m6ebev0r1d as _Temperature___init__impl__i36a2t,
  Temperature1qifhfdfpkqkr as Temperature,
  _Temperature___get_fahrenheit__impl__xao1tu21fp9sb4ltpuz as _Temperature___get_fahrenheit__impl__xao1tu,
  _Temperature___get_kelvin__impl__us25d72sz1bdqki59ou as _Temperature___get_kelvin__impl__us25d7,
  _RelativeTemperature___get_celsius__impl__beofh4vi4rzxz7zzby as _RelativeTemperature___get_celsius__impl__beofh4,
  _RelativeTemperature___init__impl__s2670v3t3o6cir0mx61 as _RelativeTemperature___init__impl__s2670v,
  RelativeTemperature2jxfnlsp9qlrv as RelativeTemperature,
  _RelativeTemperature___get_fahrenheit__impl__tymu2628ni3al6h3kd0 as _RelativeTemperature___get_fahrenheit__impl__tymu26,
  _RelativeTemperature___get_kelvin__impl__wquk3j1tjxqc3ijucsn as _RelativeTemperature___get_kelvin__impl__wquk3j,
  _DataSize___get_bytes__impl__nlgkc01z4tmgjphplqt as _DataSize___get_bytes__impl__nlgkc0,
  _DataSize___init__impl__iz9cfq2nx4f2ygs4tzd as _DataSize___init__impl__iz9cfq,
  DataSize1huql7djnl3ch as DataSize,
  _DataSize___get_kibibytes__impl__da5jmd1ypxn0qeaxzns as _DataSize___get_kibibytes__impl__da5jmd,
  _DataSize___get_mebibytes__impl__wavpgx2uvshm4k8ffs4 as _DataSize___get_mebibytes__impl__wavpgx,
  _DataSize___get_gibibytes__impl__nz4fl310l3crev7a8l4 as _DataSize___get_gibibytes__impl__nz4fl3,
  _DataSize___get_tebibytes__impl__kdhac8mxvsbapsinb7 as _DataSize___get_tebibytes__impl__kdhac8,
  _DataSize___get_decimalKilobytes__impl__rjupzq2kufobf681jxl as _DataSize___get_decimalKilobytes__impl__rjupzq,
  _DataSize___get_decimalMegabytes__impl__yffmh1604xokytgy7k as _DataSize___get_decimalMegabytes__impl__yffmh1,
  _DataSize___get_decimalGigabytes__impl__q3ocl73i5vj3rtw7nsp as _DataSize___get_decimalGigabytes__impl__q3ocl7,
  _DataSize___get_decimalTerabytes__impl__rl89rd2lw24pwer94jn as _DataSize___get_decimalTerabytes__impl__rl89rd,
  _Length___get_nanometer__impl__86nsy3iwgcd0xbqear as _Length___get_nanometer__impl__86nsy3,
  _Length___init__impl__mrryhneua5rtcihrff as _Length___init__impl__mrryhn,
  Lengthtca6d2z3zjle as Length,
  _Length___get_micrometer__impl__xab82h135ct2wvsoz7s as _Length___get_micrometer__impl__xab82h,
  _Length___get_millimeter__impl__i75bku4vgae6s0i7im as _Length___get_millimeter__impl__i75bku,
  _Length___get_centimeters__impl__ltzset3oo1ambi7xz9c as _Length___get_centimeters__impl__ltzset,
  _Length___get_meters__impl__co03t81dk8pddg1dukz as _Length___get_meters__impl__co03t8,
  _Length___get_kilometers__impl__syiikt2ggk89idxg8kf as _Length___get_kilometers__impl__syiikt,
  _Length___get_inches__impl__de09ru2w874nuco27g7 as _Length___get_inches__impl__de09ru,
  _Length___get_feet__impl__kw6lw03vnqmywlcgiiu as _Length___get_feet__impl__kw6lw0,
  _Length___get_yards__impl__8j9pnr3vhkth696eqf4 as _Length___get_yards__impl__8j9pnr,
  _Length___get_miles__impl__iwi6teo2f2mow8y1og as _Length___get_miles__impl__iwi6te,
  _Area___get_squareMillimeters__impl__fkxnwh1hx6rputs3h3k as _Area___get_squareMillimeters__impl__fkxnwh,
  _Area___get_squareCentimeters__impl__t9odvv2wxr3i0jquf45 as _Area___get_squareCentimeters__impl__t9odvv,
  _Area___get_squareMeters__impl__tdkp4u15ncadegyagje as _Area___get_squareMeters__impl__tdkp4u,
  _Area___get_hectare__impl__ftwe8j2j3yb5rotpabi as _Area___get_hectare__impl__ftwe8j,
  _Area___get_squareKilometers__impl__3iiltvxa75zm5w6d0y as _Area___get_squareKilometers__impl__3iiltv,
  _Volume___get_milliliters__impl__2fzycw32mmn1wvcv54z as _Volume___get_milliliters__impl__2fzycw,
  _Volume___get_liters__impl__yw6tctrrvnbkop7mp7 as _Volume___get_liters__impl__yw6tct,
  _Volume___get_cubicMeters__impl__6kaaeg3utu7zgy05pgj as _Volume___get_cubicMeters__impl__6kaaeg,
  _Mass___get_milligrams__impl__s8wiarnsd8uz6gmo3k as _Mass___get_milligrams__impl__s8wiar,
  _Mass___get_grams__impl__rxyb9m3dsn4n9ablui as _Mass___get_grams__impl__rxyb9m,
  _Mass___get_kilograms__impl__lr3pd5zivx4ihumesy as _Mass___get_kilograms__impl__lr3pd5,
  _Mass___get_tonnes__impl__aj2kxp3q9zh45pyc76m as _Mass___get_tonnes__impl__aj2kxp,
  _Speed___get_metersPerSecond__impl__t1zksw28hb0izniswhi as _Speed___get_metersPerSecond__impl__t1zksw,
  _Speed___get_kilometersPerHour__impl__2ucvcx2889oonv915f8 as _Speed___get_kilometersPerHour__impl__2ucvcx,
  _Acceleration___get_metersPerSecondPerSecond__impl__3zde26ph2lxv53gusg as _Acceleration___get_metersPerSecondPerSecond__impl__3zde26,
  _Acceleration___get_kilometersPerHourPerSecond__impl__toxtnn3s020ht51hgv7 as _Acceleration___get_kilometersPerHourPerSecond__impl__toxtnn,
  _Pressure___get_pascals__impl__m59t3ulrqcl9cqtk1z as _Pressure___get_pascals__impl__m59t3u,
  _Pressure___get_millibars__impl__we5tn88juiqodu1axm as _Pressure___get_millibars__impl__we5tn8,
  _Pressure___get_bars__impl__4r7a771n9cfmb5tfau4 as _Pressure___get_bars__impl__4r7a77,
} from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/usefulTypes.mjs';
import { listOfvhqybd2zx248 as listOf_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  Cents__toDouble_impl_mg3etm3dxlfojyivr3o as Cents__toDouble_impl_mg3etm,
  Companion_instance1c40ds0jrup2e as Companion_instance,
  Cents1lsbs5l1tlgw as Cents,
  Cents__toString_impl_ko5hxm1a9pwstsznn43 as Cents__toString_impl_ko5hxm,
} from '../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import { get_unpadded1ygmnwh0rw79t as get_unpadded } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { commaString1x79tfazzzauv as commaString } from '../../../../../reactive/com/lightningkite/reactive/extensions/commaString.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { isFinite2t9l5a275mxm6 as isFinite } from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { round2mrvepag8eey0 as round } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import {
  toNumber2e2hj9zugjwi2 as toNumber,
  numberToLong2pakxeg38estk as numberToLong,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
var log10 = Math.log10;
//endregion
//region block: pre-declaration
//endregion
function get_dataSizeBinaryUnits() {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return dataSizeBinaryUnits;
}
var dataSizeBinaryUnits;
function get_dataSizeDecimalUnits() {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return dataSizeDecimalUnits;
}
var dataSizeDecimalUnits;
function get_lengthMetricUnits() {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return lengthMetricUnits;
}
var lengthMetricUnits;
function get_lengthImperialUnits() {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return lengthImperialUnits;
}
var lengthImperialUnits;
function get_lengthMetricPreferred() {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return lengthMetricPreferred;
}
var lengthMetricPreferred;
function get_areaMetricUnits() {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return areaMetricUnits;
}
var areaMetricUnits;
function get_areaMetricPreferred() {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return areaMetricPreferred;
}
var areaMetricPreferred;
function get_volumeMetricUnits() {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return volumeMetricUnits;
}
var volumeMetricUnits;
function get_volumeMetricPreferred() {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return volumeMetricPreferred;
}
var volumeMetricPreferred;
function get_massMetricUnits() {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return massMetricUnits;
}
var massMetricUnits;
function get_massMetricPreferred() {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return massMetricPreferred;
}
var massMetricPreferred;
function get_speedMetricUnits() {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return speedMetricUnits;
}
var speedMetricUnits;
function get_accelerationMetricUnits() {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return accelerationMetricUnits;
}
var accelerationMetricUnits;
function get_pressureMetricUnits() {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return pressureMetricUnits;
}
var pressureMetricUnits;
function get_energyMetricUnits() {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return energyMetricUnits;
}
var energyMetricUnits;
var ValueUnitClass;
function ValueUnit() {
  if (ValueUnitClass === VOID) {
    class $ {
      constructor(symbol, fromBase, toBase) {
        this.symbol_1 = symbol;
        this.fromBase_1 = fromBase;
        this.toBase_1 = toBase;
      }
      equals(other) {
        var tmp;
        if (this === other) {
          tmp = true;
        } else {
          var tmp_0;
          if (other instanceof ValueUnit()) {
            tmp_0 = other.symbol_1 === this.symbol_1;
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      hashCode() {
        return getStringHashCode(this.symbol_1);
      }
      toString() {
        return 'ValueUnit(' + this.symbol_1 + ')';
      }
    }
    initMetadataForClass($, 'ValueUnit');
    ValueUnitClass = $;
  }
  return ValueUnitClass;
}
function registerSpecialTypes(_this__u8e3s4) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlin.uuid.Uuid'), UuidRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'com.lightningkite.uuid.Uuid'), UuidRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'com.lightningkite.Uuid'), UuidRenderer_instance);
  var _iterator__ex2g4s = listOf(['com.lightningkite', 'com.lightningkite.services.data']).iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var pkg = _iterator__ex2g4s.next_20eer_k$();
    _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, pkg + '.EmailAddress'), EmailAddressRenderer_instance);
    _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, pkg + '.PhoneNumber'), PhoneNumberRenderer_instance);
    _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, pkg + '.GeoCoordinate'), GeoCoordinateRenderer_instance);
    _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, pkg + '.DataSize'), DataSizeRenderer_getInstance());
    _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, pkg + '.Length'), LengthRenderer_getInstance());
    _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, pkg + '.Area'), AreaRenderer_getInstance());
    _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, pkg + '.Volume'), VolumeRenderer_getInstance());
    _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, pkg + '.Mass'), MassRenderer_getInstance());
    _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, pkg + '.Speed'), SpeedRenderer_getInstance());
    _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, pkg + '.Acceleration'), AccelerationRenderer_getInstance());
    _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, pkg + '.Force'), ForceRenderer_getInstance());
    _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, pkg + '.Pressure'), PressureRenderer_getInstance());
    _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, pkg + '.Energy'), EnergyRenderer_getInstance());
    _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, pkg + '.Power'), PowerRenderer_getInstance());
    _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, pkg + '.Temperature'), TemperatureRenderer_getInstance());
    _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, pkg + '.RelativeTemperature'), RelativeTemperatureRenderer_getInstance());
    _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, pkg + '.Cents'), CentsRenderer_instance);
  }
}
function UuidRenderer$form$lambda$lambda(it) {
  return it.toString();
}
function UuidRenderer$form$lambda$lambda_0(old, new_0) {
  var tmp;
  try {
    tmp = Companion_getInstance().parse_pc1q8p_k$(new_0);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Exception()) {
      var e = $p;
      tmp_0 = old;
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function UuidRenderer$form$lambda$slambda($value) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* $value.set_revjhg_k$(Companion_getInstance().random_fimq0t_k$(), $completion);
    return Unit_instance;
  }), 0);
}
var UuidRendererClass;
function UuidRenderer() {
  if (UuidRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Uuid';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_renk6_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          var this_0 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextInput())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_0.willAddChild_hz2iwc_k$(element_0);
          var tmp = UuidRenderer$form$lambda$lambda;
          element_0.bind_gesskf_k$(element_0.content_1, value.lens_u4wb4z_k$(tmp, UuidRenderer$form$lambda$lambda_0));
          element_0.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Button())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          element.willAddChild_hz2iwc_k$(element_1);
          var tmp2 = Companion_getInstance_0().sync_1;
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          var description = 'Regenerate';
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_2 = new (IconView())(element_1.get_context_h02k06_k$());
          ensureOutermostElement(element_2);
          element_1.willAddChild_hz2iwc_k$(element_2);
          element_2.set_source_3o5lkf_k$(tmp2);
          element_2.set_description_s1386w_k$(description);
          element_2.onStartup_vrxh3i_k$();
          element_1.addChild_2qpft2_k$(element_2);
          onClick(element_1, VOID, VOID, VOID, UuidRenderer$form$lambda$slambda(value));
          element_1.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_renk6_k$(context, value, module_0);
      }
      view_g906cn_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(value).toString());
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_g906cn_k$(context, value, module_0);
      }
      columnWidth_ei836w_k$(context, module_0) {
        return 24.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_ei836w_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).cellForm_4mayde_k$ = cellForm;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'UuidRenderer', VOID, VOID, [Renderer()]);
    UuidRendererClass = $;
  }
  return UuidRendererClass;
}
var UuidRenderer_instance;
function UuidRenderer_getInstance() {
  return UuidRenderer_instance;
}
function EmailAddressRenderer$form$lambda$lambda(it) {
  return _EmailAddress___get_raw__impl__6ose2(it.raw_1);
}
function EmailAddressRenderer$form$lambda$lambda_0(it) {
  return new (EmailAddress())(toEmailAddress(it));
}
var EmailAddressRendererClass;
function EmailAddressRenderer() {
  if (EmailAddressRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Email';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_f1nmmy_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextInput())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          var tmp = EmailAddressRenderer$form$lambda$lambda;
          element_0.bind_gesskf_k$(element_0.content_1, value.lens_drj4fu_k$(tmp, EmailAddressRenderer$form$lambda$lambda_0));
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          errorText(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_f1nmmy_k$(context, value, module_0);
      }
      view_6ibgcp_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.externalLink' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (ExternalLink())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
          element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => _EmailAddress___get_raw__impl__6ose2($this$invoke.invoke_r7m7el_k$(value).raw_1));
          element_0.set_wraps_9wisy1_k$(false);
          element_0.set_ellipsis_rhzl3b_k$(true);
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          var tmp_2 = KMutableProperty0();
          var tmp_3 = ExternalLink$_get_to_$ref_jqs3qa(element);
          var tmp_4 = getPropertyCallableRef('to', 0, tmp_2, tmp_3, ExternalLink$_set_to_$ref_l7iod2(element));
          element.invoke_bnq13k_k$(tmp_4, ($this$invoke) => _EmailAddress___get_url__impl__h7wdun($this$invoke.invoke_r7m7el_k$(value).raw_1));
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_6ibgcp_k$(context, value, module_0);
      }
      cellView_eiwxmv_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => _EmailAddress___get_raw__impl__6ose2($this$invoke.invoke_r7m7el_k$(value).raw_1));
          element.set_wraps_9wisy1_k$(false);
          element.set_ellipsis_rhzl3b_k$(true);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_eiwxmv_k$(context, value, module_0);
      }
      columnWidth_91r94p_k$(context, module_0) {
        return 20.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_91r94p_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellForm_4mayde_k$ = cellForm;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'EmailAddressRenderer', VOID, VOID, [Renderer()]);
    EmailAddressRendererClass = $;
  }
  return EmailAddressRendererClass;
}
var EmailAddressRenderer_instance;
function EmailAddressRenderer_getInstance() {
  return EmailAddressRenderer_instance;
}
function PhoneNumberRenderer$form$lambda$lambda(it) {
  return _PhoneNumber___get_raw__impl__gc2pmp(it.raw_1);
}
function PhoneNumberRenderer$form$lambda$lambda_0(it) {
  return new (PhoneNumber())(toPhoneNumber(it));
}
var PhoneNumberRendererClass;
function PhoneNumberRenderer() {
  if (PhoneNumberRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Phone';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_udi13u_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextInput())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          var tmp = PhoneNumberRenderer$form$lambda$lambda;
          element_0.bind_gesskf_k$(element_0.content_1, value.lens_drj4fu_k$(tmp, PhoneNumberRenderer$form$lambda$lambda_0));
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          errorText(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_udi13u_k$(context, value, module_0);
      }
      view_ysm7y9_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.externalLink' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (ExternalLink())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
          element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => _PhoneNumber___get_raw__impl__gc2pmp($this$invoke.invoke_r7m7el_k$(value).raw_1));
          element_0.set_wraps_9wisy1_k$(false);
          element_0.set_ellipsis_rhzl3b_k$(true);
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          var tmp_2 = KMutableProperty0();
          var tmp_3 = ExternalLink$_get_to_$ref_jqs3qa(element);
          var tmp_4 = getPropertyCallableRef('to', 0, tmp_2, tmp_3, ExternalLink$_set_to_$ref_l7iod2(element));
          element.invoke_bnq13k_k$(tmp_4, ($this$invoke) => _PhoneNumber___get_url__impl__12igm0($this$invoke.invoke_r7m7el_k$(value).raw_1));
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_ysm7y9_k$(context, value, module_0);
      }
      cellView_ao4mt9_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => _PhoneNumber___get_raw__impl__gc2pmp($this$invoke.invoke_r7m7el_k$(value).raw_1));
          element.set_wraps_9wisy1_k$(false);
          element.set_ellipsis_rhzl3b_k$(true);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_ao4mt9_k$(context, value, module_0);
      }
      columnWidth_b27cpq_k$(context, module_0) {
        return 15.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_b27cpq_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellForm_4mayde_k$ = cellForm;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'PhoneNumberRenderer', VOID, VOID, [Renderer()]);
    PhoneNumberRendererClass = $;
  }
  return PhoneNumberRendererClass;
}
var PhoneNumberRenderer_instance;
function PhoneNumberRenderer_getInstance() {
  return PhoneNumberRenderer_instance;
}
function GeoCoordinateRenderer$form$lambda$lambda(it) {
  return it.latitude_1;
}
function GeoCoordinateRenderer$form$lambda$lambda_0(old, new_0) {
  return old.copy$default_am4guy_k$(new_0 == null ? 0.0 : new_0);
}
function GeoCoordinateRenderer$form$lambda$lambda_1(it) {
  return it.longitude_1;
}
function GeoCoordinateRenderer$form$lambda$lambda_2(old, new_0) {
  return old.copy$default_am4guy_k$(VOID, new_0 == null ? 0.0 : new_0);
}
var GeoCoordinateRendererClass;
function GeoCoordinateRenderer() {
  if (GeoCoordinateRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Coordinates';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_vdjqv2_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var this_0 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
          var this_1 = themed(this_0, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (NumberInput())(this_1.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_1.willAddChild_hz2iwc_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.NumberInput.hint' call
          var value_0 = 'Latitude';
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          element_0.native_1.attributes_1.native_1.placeholder = value_0;
          var tmp = GeoCoordinateRenderer$form$lambda$lambda;
          element_0.bind_gesskf_k$(element_0.content_1, value.lens_u4wb4z_k$(tmp, GeoCoordinateRenderer$form$lambda$lambda_0));
          element_0.onStartup_vrxh3i_k$();
          this_1.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var this_2 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
          var this_3 = themed(this_2, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (NumberInput())(this_3.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_3.willAddChild_hz2iwc_k$(element_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.NumberInput.hint' call
          var value_1 = 'Longitude';
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          element_1.native_1.attributes_1.native_1.placeholder = value_1;
          var tmp_0 = GeoCoordinateRenderer$form$lambda$lambda_1;
          element_1.bind_gesskf_k$(element_1.content_1, value.lens_u4wb4z_k$(tmp_0, GeoCoordinateRenderer$form$lambda$lambda_2));
          element_1.onStartup_vrxh3i_k$();
          this_3.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_vdjqv2_k$(context, value, module_0);
      }
      view_6agt4v_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => '' + $this$invoke.invoke_r7m7el_k$(value).latitude_1 + ', ' + $this$invoke.invoke_r7m7el_k$(value).longitude_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_6agt4v_k$(context, value, module_0);
      }
      columnWidth_bclbkg_k$(context, module_0) {
        return 20.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_bclbkg_k$(context, module_0);
      }
      labeledForm_7va6qg_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          var tmp2 = label;
          // Inline function 'com.lightningkite.kiteui.forms.fieldWithoutBorder' call
          var description_0 = description;
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          element_0.set_gap_jwjroq_k$(get_rem(0.25));
          text(themed(get_centered(element_0), LabelSemantic_getInstance()), tmp2);
          if (!(description_0 == null)) {
            var tmp0 = textPopover(get_centered(element_0), description_0);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance_0().info_1.resize_q1xpz0_k$(get_rem_0(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          GeoCoordinateRenderer_instance.form_vdjqv2_k$(context, value, module_0)(element);
          errorText(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledForm_ughtr2_k$(context, value, module_0, label, description) {
        return this.labeledForm_7va6qg_k$(context, value, module_0, label, description);
      }
      labeledView_ndusmx_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          var tmp2 = label;
          // Inline function 'com.lightningkite.kiteui.forms.fieldWithoutBorder' call
          var description_0 = description;
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          element_0.set_gap_jwjroq_k$(get_rem(0.25));
          text(themed(get_centered(element_0), LabelSemantic_getInstance()), tmp2);
          if (!(description_0 == null)) {
            var tmp0 = textPopover(get_centered(element_0), description_0);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance_0().info_1.resize_q1xpz0_k$(get_rem_0(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          GeoCoordinateRenderer_instance.view_6agt4v_k$(context, value, module_0)(element);
          errorText(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledView_aldyvt_k$(context, value, module_0, label, description) {
        return this.labeledView_ndusmx_k$(context, value, module_0, label, description);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).cellForm_4mayde_k$ = cellForm;
    initMetadataForObject($, 'GeoCoordinateRenderer', VOID, VOID, [Renderer()]);
    GeoCoordinateRendererClass = $;
  }
  return GeoCoordinateRendererClass;
}
var GeoCoordinateRenderer_instance;
function GeoCoordinateRenderer_getInstance() {
  return GeoCoordinateRenderer_instance;
}
var DataSizeRendererClass;
function DataSizeRenderer() {
  if (DataSizeRendererClass === VOID) {
    class $ extends NumericValueClassRenderer() {
      constructor() {
        DataSizeRenderer_instance = null;
        super('Data Size', plus(get_dataSizeBinaryUnits(), get_dataSizeDecimalUnits()), get_dataSizeBinaryUnits());
        DataSizeRenderer_instance = this;
      }
    }
    initMetadataForObject($, 'DataSizeRenderer');
    DataSizeRendererClass = $;
  }
  return DataSizeRendererClass;
}
var DataSizeRenderer_instance;
function DataSizeRenderer_getInstance() {
  if (DataSizeRenderer_instance === VOID)
    new (DataSizeRenderer())();
  return DataSizeRenderer_instance;
}
var LengthRendererClass;
function LengthRenderer() {
  if (LengthRendererClass === VOID) {
    class $ extends NumericValueClassRenderer() {
      constructor() {
        LengthRenderer_instance = null;
        super('Length', plus(get_lengthMetricUnits(), get_lengthImperialUnits()), get_lengthMetricPreferred());
        LengthRenderer_instance = this;
      }
    }
    initMetadataForObject($, 'LengthRenderer');
    LengthRendererClass = $;
  }
  return LengthRendererClass;
}
var LengthRenderer_instance;
function LengthRenderer_getInstance() {
  if (LengthRenderer_instance === VOID)
    new (LengthRenderer())();
  return LengthRenderer_instance;
}
function AreaRenderer$_init_$lambda_ei1syj(it) {
  return _Area___get_acres__impl__gakf2d(it.squareMeters_1);
}
function AreaRenderer$_init_$lambda_ei1syj_0(it) {
  return new (Area())(_Area___init__impl__ijsx70(it * 4046.8564224));
}
var AreaRendererClass;
function AreaRenderer() {
  if (AreaRendererClass === VOID) {
    class $ extends NumericValueClassRenderer() {
      constructor() {
        AreaRenderer_instance = null;
        var tmp = get_areaMetricUnits();
        var tmp_0 = AreaRenderer$_init_$lambda_ei1syj;
        super('Area', plus(tmp, listOf_0(new (ValueUnit())('acres', tmp_0, AreaRenderer$_init_$lambda_ei1syj_0))), get_areaMetricPreferred());
        AreaRenderer_instance = this;
      }
    }
    initMetadataForObject($, 'AreaRenderer');
    AreaRendererClass = $;
  }
  return AreaRendererClass;
}
var AreaRenderer_instance;
function AreaRenderer_getInstance() {
  if (AreaRenderer_instance === VOID)
    new (AreaRenderer())();
  return AreaRenderer_instance;
}
function VolumeRenderer$_init_$lambda_vcpype(it) {
  return _Volume___get_liquidOunces__impl__d78jyr(it.cubicMeters_1);
}
function VolumeRenderer$_init_$lambda_vcpype_0(it) {
  return new (Volume())(_Volume___init__impl__tjrqop(it * 2.957352956250001E-5));
}
function VolumeRenderer$_init_$lambda_vcpype_1(it) {
  return _Volume___get_cups__impl__tqhzrx(it.cubicMeters_1);
}
function VolumeRenderer$_init_$lambda_vcpype_2(it) {
  return new (Volume())(_Volume___init__impl__tjrqop(it * 2.365882365000001E-4));
}
function VolumeRenderer$_init_$lambda_vcpype_3(it) {
  return _Volume___get_pints__impl__mv7688(it.cubicMeters_1);
}
function VolumeRenderer$_init_$lambda_vcpype_4(it) {
  return new (Volume())(_Volume___init__impl__tjrqop(it * 4.731764730000002E-4));
}
function VolumeRenderer$_init_$lambda_vcpype_5(it) {
  return _Volume___get_quarts__impl__2w1hjy(it.cubicMeters_1);
}
function VolumeRenderer$_init_$lambda_vcpype_6(it) {
  return new (Volume())(_Volume___init__impl__tjrqop(it * 9.463529460000004E-4));
}
function VolumeRenderer$_init_$lambda_vcpype_7(it) {
  return _Volume___get_gallons__impl__smxhou(it.cubicMeters_1);
}
function VolumeRenderer$_init_$lambda_vcpype_8(it) {
  return new (Volume())(_Volume___init__impl__tjrqop(it * 0.0037854117840000014));
}
function VolumeRenderer$_init_$lambda_vcpype_9(it) {
  return _Volume___get_cubicFeet__impl__wre3yk(it.cubicMeters_1);
}
function VolumeRenderer$_init_$lambda_vcpype_10(it) {
  return new (Volume())(_Volume___init__impl__tjrqop(it * 0.028316846592000004));
}
var VolumeRendererClass;
function VolumeRenderer() {
  if (VolumeRendererClass === VOID) {
    class $ extends NumericValueClassRenderer() {
      constructor() {
        VolumeRenderer_instance = null;
        var tmp = get_volumeMetricUnits();
        var tmp_0 = VolumeRenderer$_init_$lambda_vcpype;
        var tmp_1 = new (ValueUnit())('fl oz', tmp_0, VolumeRenderer$_init_$lambda_vcpype_0);
        var tmp_2 = VolumeRenderer$_init_$lambda_vcpype_1;
        var tmp_3 = new (ValueUnit())('cup', tmp_2, VolumeRenderer$_init_$lambda_vcpype_2);
        var tmp_4 = VolumeRenderer$_init_$lambda_vcpype_3;
        var tmp_5 = new (ValueUnit())('pt', tmp_4, VolumeRenderer$_init_$lambda_vcpype_4);
        var tmp_6 = VolumeRenderer$_init_$lambda_vcpype_5;
        var tmp_7 = new (ValueUnit())('qt', tmp_6, VolumeRenderer$_init_$lambda_vcpype_6);
        var tmp_8 = VolumeRenderer$_init_$lambda_vcpype_7;
        var tmp_9 = new (ValueUnit())('gal', tmp_8, VolumeRenderer$_init_$lambda_vcpype_8);
        var tmp_10 = VolumeRenderer$_init_$lambda_vcpype_9;
        super('Volume', plus(tmp, listOf([tmp_1, tmp_3, tmp_5, tmp_7, tmp_9, new (ValueUnit())('ft\xB3', tmp_10, VolumeRenderer$_init_$lambda_vcpype_10)])), get_volumeMetricPreferred());
        VolumeRenderer_instance = this;
      }
    }
    initMetadataForObject($, 'VolumeRenderer');
    VolumeRendererClass = $;
  }
  return VolumeRendererClass;
}
var VolumeRenderer_instance;
function VolumeRenderer_getInstance() {
  if (VolumeRenderer_instance === VOID)
    new (VolumeRenderer())();
  return VolumeRenderer_instance;
}
function MassRenderer$_init_$lambda_7al3rg(it) {
  return _Mass___get_weightOunces__impl__w4i8hh(it.kilograms_1);
}
function MassRenderer$_init_$lambda_7al3rg_0(it) {
  return new (Mass())(_Mass___init__impl__g55pzh(it * 0.028349523125));
}
function MassRenderer$_init_$lambda_7al3rg_1(it) {
  return _Mass___get_pounds__impl__r7075n(it.kilograms_1);
}
function MassRenderer$_init_$lambda_7al3rg_2(it) {
  return new (Mass())(_Mass___init__impl__g55pzh(it * 0.45359237));
}
function MassRenderer$_init_$lambda_7al3rg_3(it) {
  return _Mass___get_tons__impl__so9xvw(it.kilograms_1);
}
function MassRenderer$_init_$lambda_7al3rg_4(it) {
  return new (Mass())(_Mass___init__impl__g55pzh(it * 907.18474));
}
var MassRendererClass;
function MassRenderer() {
  if (MassRendererClass === VOID) {
    class $ extends NumericValueClassRenderer() {
      constructor() {
        MassRenderer_instance = null;
        var tmp = get_massMetricUnits();
        var tmp_0 = MassRenderer$_init_$lambda_7al3rg;
        var tmp_1 = new (ValueUnit())('oz', tmp_0, MassRenderer$_init_$lambda_7al3rg_0);
        var tmp_2 = MassRenderer$_init_$lambda_7al3rg_1;
        var tmp_3 = new (ValueUnit())('lb', tmp_2, MassRenderer$_init_$lambda_7al3rg_2);
        var tmp_4 = MassRenderer$_init_$lambda_7al3rg_3;
        super('Mass', plus(tmp, listOf([tmp_1, tmp_3, new (ValueUnit())('ton', tmp_4, MassRenderer$_init_$lambda_7al3rg_4)])), get_massMetricPreferred());
        MassRenderer_instance = this;
      }
    }
    initMetadataForObject($, 'MassRenderer');
    MassRendererClass = $;
  }
  return MassRendererClass;
}
var MassRenderer_instance;
function MassRenderer_getInstance() {
  if (MassRenderer_instance === VOID)
    new (MassRenderer())();
  return MassRenderer_instance;
}
function SpeedRenderer$_init_$lambda_8v657l(it) {
  return _Speed___get_feetPerSecond__impl__vx28ng(it.metersPerSecond_1);
}
function SpeedRenderer$_init_$lambda_8v657l_0(it) {
  return new (Speed())(_Speed___init__impl__580hla(it * 0.3048));
}
function SpeedRenderer$_init_$lambda_8v657l_1(it) {
  return _Speed___get_milesPerHour__impl__yxl3t0(it.metersPerSecond_1);
}
function SpeedRenderer$_init_$lambda_8v657l_2(it) {
  return new (Speed())(_Speed___init__impl__580hla(it * 0.44704));
}
var SpeedRendererClass;
function SpeedRenderer() {
  if (SpeedRendererClass === VOID) {
    class $ extends NumericValueClassRenderer() {
      constructor() {
        SpeedRenderer_instance = null;
        var tmp = get_speedMetricUnits();
        var tmp_0 = SpeedRenderer$_init_$lambda_8v657l;
        var tmp_1 = new (ValueUnit())('ft/s', tmp_0, SpeedRenderer$_init_$lambda_8v657l_0);
        var tmp_2 = SpeedRenderer$_init_$lambda_8v657l_1;
        super('Speed', plus(tmp, listOf([tmp_1, new (ValueUnit())('mph', tmp_2, SpeedRenderer$_init_$lambda_8v657l_2)])), get_speedMetricUnits());
        SpeedRenderer_instance = this;
      }
    }
    initMetadataForObject($, 'SpeedRenderer');
    SpeedRendererClass = $;
  }
  return SpeedRendererClass;
}
var SpeedRenderer_instance;
function SpeedRenderer_getInstance() {
  if (SpeedRenderer_instance === VOID)
    new (SpeedRenderer())();
  return SpeedRenderer_instance;
}
function AccelerationRenderer$_init_$lambda_gcmpm0(it) {
  return _Acceleration___get_feetPerSecondPerSecond__impl__3tkghi(it.metersPerSecondPerSecond_1);
}
function AccelerationRenderer$_init_$lambda_gcmpm0_0(it) {
  return new (Acceleration())(_Acceleration___init__impl__lpurpb(it * 0.3048));
}
function AccelerationRenderer$_init_$lambda_gcmpm0_1(it) {
  return _Acceleration___get_milesPerHourPerSecond__impl__umq308(it.metersPerSecondPerSecond_1);
}
function AccelerationRenderer$_init_$lambda_gcmpm0_2(it) {
  return new (Acceleration())(_Acceleration___init__impl__lpurpb(it * 0.44704));
}
var AccelerationRendererClass;
function AccelerationRenderer() {
  if (AccelerationRendererClass === VOID) {
    class $ extends NumericValueClassRenderer() {
      constructor() {
        AccelerationRenderer_instance = null;
        var tmp = get_accelerationMetricUnits();
        var tmp_0 = AccelerationRenderer$_init_$lambda_gcmpm0;
        var tmp_1 = new (ValueUnit())('ft/s\xB2', tmp_0, AccelerationRenderer$_init_$lambda_gcmpm0_0);
        var tmp_2 = AccelerationRenderer$_init_$lambda_gcmpm0_1;
        super('Acceleration', plus(tmp, listOf([tmp_1, new (ValueUnit())('mph/s', tmp_2, AccelerationRenderer$_init_$lambda_gcmpm0_2)])), get_accelerationMetricUnits());
        AccelerationRenderer_instance = this;
      }
    }
    initMetadataForObject($, 'AccelerationRenderer');
    AccelerationRendererClass = $;
  }
  return AccelerationRendererClass;
}
var AccelerationRenderer_instance;
function AccelerationRenderer_getInstance() {
  if (AccelerationRenderer_instance === VOID)
    new (AccelerationRenderer())();
  return AccelerationRenderer_instance;
}
function ForceRenderer$_init_$lambda_mtf0d(it) {
  return _Force___get_newtons__impl__qua8gd(it.newtons_1);
}
function ForceRenderer$_init_$lambda_mtf0d_0(it) {
  return new (Force())(_Force___init__impl__w7900e(it));
}
function ForceRenderer$_init_$lambda_mtf0d_1(it) {
  return _Force___get_poundForce__impl__ne6ai4(it.newtons_1);
}
function ForceRenderer$_init_$lambda_mtf0d_2(it) {
  return new (Force())(_Force___init__impl__w7900e(it * 4.448222));
}
function ForceRenderer$_init_$lambda_mtf0d_3(it) {
  return _Force___get_newtons__impl__qua8gd(it.newtons_1);
}
function ForceRenderer$_init_$lambda_mtf0d_4(it) {
  return new (Force())(_Force___init__impl__w7900e(it));
}
var ForceRendererClass;
function ForceRenderer() {
  if (ForceRendererClass === VOID) {
    class $ extends NumericValueClassRenderer() {
      constructor() {
        ForceRenderer_instance = null;
        var tmp = ForceRenderer$_init_$lambda_mtf0d;
        var tmp_0 = new (ValueUnit())('N', tmp, ForceRenderer$_init_$lambda_mtf0d_0);
        var tmp_1 = ForceRenderer$_init_$lambda_mtf0d_1;
        var tmp_2 = listOf([tmp_0, new (ValueUnit())('lbf', tmp_1, ForceRenderer$_init_$lambda_mtf0d_2)]);
        var tmp_3 = ForceRenderer$_init_$lambda_mtf0d_3;
        super('Force', tmp_2, listOf_0(new (ValueUnit())('N', tmp_3, ForceRenderer$_init_$lambda_mtf0d_4)));
        ForceRenderer_instance = this;
      }
    }
    initMetadataForObject($, 'ForceRenderer');
    ForceRendererClass = $;
  }
  return ForceRendererClass;
}
var ForceRenderer_instance;
function ForceRenderer_getInstance() {
  if (ForceRenderer_instance === VOID)
    new (ForceRenderer())();
  return ForceRenderer_instance;
}
function PressureRenderer$_init_$lambda_1y5mu5(it) {
  return _Pressure___get_atmospheres__impl__m90i7k(it.pascals_1);
}
function PressureRenderer$_init_$lambda_1y5mu5_0(it) {
  return new (Pressure())(_Pressure___init__impl__4rek04(it * 101325.0));
}
function PressureRenderer$_init_$lambda_1y5mu5_1(it) {
  return _Pressure___get_psi__impl__877eh1(it.pascals_1);
}
function PressureRenderer$_init_$lambda_1y5mu5_2(it) {
  return new (Pressure())(_Pressure___init__impl__4rek04(it * 6894.757889515778));
}
var PressureRendererClass;
function PressureRenderer() {
  if (PressureRendererClass === VOID) {
    class $ extends NumericValueClassRenderer() {
      constructor() {
        PressureRenderer_instance = null;
        var tmp = get_pressureMetricUnits();
        var tmp_0 = PressureRenderer$_init_$lambda_1y5mu5;
        var tmp_1 = new (ValueUnit())('atm', tmp_0, PressureRenderer$_init_$lambda_1y5mu5_0);
        var tmp_2 = PressureRenderer$_init_$lambda_1y5mu5_1;
        super('Pressure', plus(tmp, listOf([tmp_1, new (ValueUnit())('psi', tmp_2, PressureRenderer$_init_$lambda_1y5mu5_2)])), get_pressureMetricUnits());
        PressureRenderer_instance = this;
      }
    }
    initMetadataForObject($, 'PressureRenderer');
    PressureRendererClass = $;
  }
  return PressureRendererClass;
}
var PressureRenderer_instance;
function PressureRenderer_getInstance() {
  if (PressureRenderer_instance === VOID)
    new (PressureRenderer())();
  return PressureRenderer_instance;
}
function EnergyRenderer$_init_$lambda_yda71c(it) {
  return _Energy___get_joules__impl__q784q(it.joules_1) / 4184.0;
}
function EnergyRenderer$_init_$lambda_yda71c_0(it) {
  return new (Energy())(_Energy___init__impl__paow1l(it * 4184.0));
}
function EnergyRenderer$_init_$lambda_yda71c_1(it) {
  return _Energy___get_joules__impl__q784q(it.joules_1) / 1055.05585262;
}
function EnergyRenderer$_init_$lambda_yda71c_2(it) {
  return new (Energy())(_Energy___init__impl__paow1l(it * 1055.05585262));
}
var EnergyRendererClass;
function EnergyRenderer() {
  if (EnergyRendererClass === VOID) {
    class $ extends NumericValueClassRenderer() {
      constructor() {
        EnergyRenderer_instance = null;
        var tmp = get_energyMetricUnits();
        var tmp_0 = EnergyRenderer$_init_$lambda_yda71c;
        var tmp_1 = new (ValueUnit())('kcal', tmp_0, EnergyRenderer$_init_$lambda_yda71c_0);
        var tmp_2 = EnergyRenderer$_init_$lambda_yda71c_1;
        super('Energy', plus(tmp, listOf([tmp_1, new (ValueUnit())('BTU', tmp_2, EnergyRenderer$_init_$lambda_yda71c_2)])), get_energyMetricUnits());
        EnergyRenderer_instance = this;
      }
    }
    initMetadataForObject($, 'EnergyRenderer');
    EnergyRendererClass = $;
  }
  return EnergyRendererClass;
}
var EnergyRenderer_instance;
function EnergyRenderer_getInstance() {
  if (EnergyRenderer_instance === VOID)
    new (EnergyRenderer())();
  return EnergyRenderer_instance;
}
function PowerRenderer$_init_$lambda_w34omb(it) {
  return _Power___get_watts__impl__8v3onk(it.watts_1);
}
function PowerRenderer$_init_$lambda_w34omb_0(it) {
  return new (Power())(_Power___init__impl__y6lnpo(it));
}
function PowerRenderer$_init_$lambda_w34omb_1(it) {
  return _Power___get_kilowatts__impl__xnqgmn(it.watts_1);
}
function PowerRenderer$_init_$lambda_w34omb_2(it) {
  return new (Power())(_Power___init__impl__y6lnpo(it * 1000.0));
}
function PowerRenderer$_init_$lambda_w34omb_3(it) {
  return _Power___get_watts__impl__8v3onk(it.watts_1) / 1000000.0;
}
function PowerRenderer$_init_$lambda_w34omb_4(it) {
  return new (Power())(_Power___init__impl__y6lnpo(it * 1000000.0));
}
var PowerRendererClass;
function PowerRenderer() {
  if (PowerRendererClass === VOID) {
    class $ extends NumericValueClassRenderer() {
      constructor() {
        PowerRenderer_instance = null;
        var tmp = PowerRenderer$_init_$lambda_w34omb;
        var tmp_0 = new (ValueUnit())('W', tmp, PowerRenderer$_init_$lambda_w34omb_0);
        var tmp_1 = PowerRenderer$_init_$lambda_w34omb_1;
        var tmp_2 = new (ValueUnit())('kW', tmp_1, PowerRenderer$_init_$lambda_w34omb_2);
        var tmp_3 = PowerRenderer$_init_$lambda_w34omb_3;
        super('Power', listOf([tmp_0, tmp_2, new (ValueUnit())('MW', tmp_3, PowerRenderer$_init_$lambda_w34omb_4)]));
        PowerRenderer_instance = this;
      }
    }
    initMetadataForObject($, 'PowerRenderer');
    PowerRendererClass = $;
  }
  return PowerRendererClass;
}
var PowerRenderer_instance;
function PowerRenderer_getInstance() {
  if (PowerRenderer_instance === VOID)
    new (PowerRenderer())();
  return PowerRenderer_instance;
}
function TemperatureRenderer$_init_$lambda_ac3nnw(it) {
  return _Temperature___get_celsius__impl__lhbsrw(it.celsius_1);
}
function TemperatureRenderer$_init_$lambda_ac3nnw_0(it) {
  return new (Temperature())(_Temperature___init__impl__i36a2t(it));
}
function TemperatureRenderer$_init_$lambda_ac3nnw_1(it) {
  return _Temperature___get_fahrenheit__impl__xao1tu(it.celsius_1);
}
function TemperatureRenderer$_init_$lambda_ac3nnw_2(it) {
  return new (Temperature())(_Temperature___init__impl__i36a2t((it - 32.0) * 5.0 / 9.0));
}
function TemperatureRenderer$_init_$lambda_ac3nnw_3(it) {
  return _Temperature___get_kelvin__impl__us25d7(it.celsius_1);
}
function TemperatureRenderer$_init_$lambda_ac3nnw_4(it) {
  return new (Temperature())(_Temperature___init__impl__i36a2t(it - 273.15));
}
function TemperatureRenderer$_init_$lambda_ac3nnw_5(it) {
  return _Temperature___get_celsius__impl__lhbsrw(it.celsius_1);
}
function TemperatureRenderer$_init_$lambda_ac3nnw_6(it) {
  return new (Temperature())(_Temperature___init__impl__i36a2t(it));
}
var TemperatureRendererClass;
function TemperatureRenderer() {
  if (TemperatureRendererClass === VOID) {
    class $ extends NumericValueClassRenderer() {
      constructor() {
        TemperatureRenderer_instance = null;
        var tmp = TemperatureRenderer$_init_$lambda_ac3nnw;
        var tmp_0 = new (ValueUnit())('\xB0C', tmp, TemperatureRenderer$_init_$lambda_ac3nnw_0);
        var tmp_1 = TemperatureRenderer$_init_$lambda_ac3nnw_1;
        var tmp_2 = new (ValueUnit())('\xB0F', tmp_1, TemperatureRenderer$_init_$lambda_ac3nnw_2);
        var tmp_3 = TemperatureRenderer$_init_$lambda_ac3nnw_3;
        var tmp_4 = listOf([tmp_0, tmp_2, new (ValueUnit())('K', tmp_3, TemperatureRenderer$_init_$lambda_ac3nnw_4)]);
        var tmp_5 = TemperatureRenderer$_init_$lambda_ac3nnw_5;
        super('Temperature', tmp_4, listOf_0(new (ValueUnit())('\xB0C', tmp_5, TemperatureRenderer$_init_$lambda_ac3nnw_6)));
        TemperatureRenderer_instance = this;
      }
    }
    initMetadataForObject($, 'TemperatureRenderer');
    TemperatureRendererClass = $;
  }
  return TemperatureRendererClass;
}
var TemperatureRenderer_instance;
function TemperatureRenderer_getInstance() {
  if (TemperatureRenderer_instance === VOID)
    new (TemperatureRenderer())();
  return TemperatureRenderer_instance;
}
function RelativeTemperatureRenderer$_init_$lambda_o9yp7k(it) {
  return _RelativeTemperature___get_celsius__impl__beofh4(it.celsius_1);
}
function RelativeTemperatureRenderer$_init_$lambda_o9yp7k_0(it) {
  return new (RelativeTemperature())(_RelativeTemperature___init__impl__s2670v(it));
}
function RelativeTemperatureRenderer$_init_$lambda_o9yp7k_1(it) {
  return _RelativeTemperature___get_fahrenheit__impl__tymu26(it.celsius_1);
}
function RelativeTemperatureRenderer$_init_$lambda_o9yp7k_2(it) {
  return new (RelativeTemperature())(_RelativeTemperature___init__impl__s2670v(it * 5.0 / 9.0));
}
function RelativeTemperatureRenderer$_init_$lambda_o9yp7k_3(it) {
  return _RelativeTemperature___get_kelvin__impl__wquk3j(it.celsius_1);
}
function RelativeTemperatureRenderer$_init_$lambda_o9yp7k_4(it) {
  return new (RelativeTemperature())(_RelativeTemperature___init__impl__s2670v(it));
}
function RelativeTemperatureRenderer$_init_$lambda_o9yp7k_5(it) {
  return _RelativeTemperature___get_celsius__impl__beofh4(it.celsius_1);
}
function RelativeTemperatureRenderer$_init_$lambda_o9yp7k_6(it) {
  return new (RelativeTemperature())(_RelativeTemperature___init__impl__s2670v(it));
}
var RelativeTemperatureRendererClass;
function RelativeTemperatureRenderer() {
  if (RelativeTemperatureRendererClass === VOID) {
    class $ extends NumericValueClassRenderer() {
      constructor() {
        RelativeTemperatureRenderer_instance = null;
        var tmp = RelativeTemperatureRenderer$_init_$lambda_o9yp7k;
        var tmp_0 = new (ValueUnit())('\u0394\xB0C', tmp, RelativeTemperatureRenderer$_init_$lambda_o9yp7k_0);
        var tmp_1 = RelativeTemperatureRenderer$_init_$lambda_o9yp7k_1;
        var tmp_2 = new (ValueUnit())('\u0394\xB0F', tmp_1, RelativeTemperatureRenderer$_init_$lambda_o9yp7k_2);
        var tmp_3 = RelativeTemperatureRenderer$_init_$lambda_o9yp7k_3;
        var tmp_4 = listOf([tmp_0, tmp_2, new (ValueUnit())('\u0394K', tmp_3, RelativeTemperatureRenderer$_init_$lambda_o9yp7k_4)]);
        var tmp_5 = RelativeTemperatureRenderer$_init_$lambda_o9yp7k_5;
        super('Temperature Difference', tmp_4, listOf_0(new (ValueUnit())('\u0394\xB0C', tmp_5, RelativeTemperatureRenderer$_init_$lambda_o9yp7k_6)));
        RelativeTemperatureRenderer_instance = this;
      }
    }
    initMetadataForObject($, 'RelativeTemperatureRenderer');
    RelativeTemperatureRendererClass = $;
  }
  return RelativeTemperatureRendererClass;
}
var RelativeTemperatureRenderer_instance;
function RelativeTemperatureRenderer_getInstance() {
  if (RelativeTemperatureRenderer_instance === VOID)
    new (RelativeTemperatureRenderer())();
  return RelativeTemperatureRenderer_instance;
}
function CentsRenderer$form$lambda$lambda(it) {
  return Cents__toDouble_impl_mg3etm(it.inCents_1);
}
function CentsRenderer$form$lambda$lambda_0(it) {
  var tmp1_elvis_lhs = it == null ? null : Companion_instance.get_dollars_vjjqkb_k$(it);
  var tmp;
  var tmp_0 = tmp1_elvis_lhs;
  if ((tmp_0 == null ? null : new (Cents())(tmp_0)) == null) {
    tmp = Companion_instance.get_cents_3bbzqx_k$(0);
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return new (Cents())(tmp);
}
var CentsRendererClass;
function CentsRenderer() {
  if (CentsRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Dollars and Cents';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_724tq6_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          var this_0 = get_unpadded(_this__u8e3s4);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          var this_1 = get_centered(element);
          var tmp$ret$4 = themed(this_1, ForcePaddingSemantic_getInstance());
          text(tmp$ret$4, '$');
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          var this_2 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
          var this_3 = themed(this_2, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (NumberInput())(this_3.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_3.willAddChild_hz2iwc_k$(element_0);
          element_0.set_align_ypalx0_k$(Align_End_getInstance());
          var tmp = CentsRenderer$form$lambda$lambda;
          element_0.bind_gesskf_k$(element_0.content_1, value.lens_drj4fu_k$(tmp, CentsRenderer$form$lambda$lambda_0));
          element_0.onStartup_vrxh3i_k$();
          this_3.addChild_2qpft2_k$(element_0);
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_724tq6_k$(context, value, module_0);
      }
      view_5stewv_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_align_ypalx0_k$(Align_End_getInstance());
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => Cents__toString_impl_ko5hxm($this$invoke.invoke_r7m7el_k$(value).inCents_1));
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_5stewv_k$(context, value, module_0);
      }
      cellView_jou399_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_align_ypalx0_k$(Align_End_getInstance());
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => Cents__toString_impl_ko5hxm($this$invoke.invoke_r7m7el_k$(value).inCents_1));
          element.set_wraps_9wisy1_k$(false);
          element.set_ellipsis_rhzl3b_k$(true);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_jou399_k$(context, value, module_0);
      }
      columnWidth_qbju26_k$(context, module_0) {
        return 8.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_qbju26_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellForm_4mayde_k$ = cellForm;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'CentsRenderer', VOID, VOID, [Renderer()]);
    CentsRendererClass = $;
  }
  return CentsRendererClass;
}
var CentsRenderer_instance;
function CentsRenderer_getInstance() {
  return CentsRenderer_instance;
}
function NumericValueClassRenderer$form$lambda$lambda(it) {
  return it.symbol_1;
}
var NumericValueClassRendererClass;
function NumericValueClassRenderer() {
  if (NumericValueClassRendererClass === VOID) {
    class $ {
      constructor(name, units, preferredUnits) {
        preferredUnits = preferredUnits === VOID ? units : preferredUnits;
        this.name_1 = name;
        this.units_1 = units;
        this.preferredUnits_1 = preferredUnits;
        // Inline function 'kotlin.collections.isNotEmpty' call
        // Inline function 'kotlin.require' call
        if (!!this.units_1.isEmpty_y1axqb_k$()) {
          var message = this.get_name_woqyms_k$() + ' renderer requires at least one unit';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.collections.isNotEmpty' call
        // Inline function 'kotlin.require' call
        if (!!this.preferredUnits_1.isEmpty_y1axqb_k$()) {
          var message_0 = this.get_name_woqyms_k$() + ' renderer requires at least one preferred unit';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      pickUnit_sob447_k$(value) {
        return pickByMagnitude(value, this.preferredUnits_1);
      }
      format_rk25g1_k$(magnitude) {
        return commaString(toSignificantDigits(magnitude, 3));
      }
      form_gie6yk_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(value.get_state_wc71uu_k$());
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp = this.pickUnit_sob447_k$(tmp0_safe_receiver);
          }
          var tmp1_elvis_lhs = tmp;
          var initialUnit = tmp1_elvis_lhs == null ? first(this.preferredUnits_1) : tmp1_elvis_lhs;
          var unitChoice = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(initialUnit);
          var unitOptions = _Constant___init__impl__v45mub(this.units_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          var this_0 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (Frame())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_0.willAddChild_hz2iwc_k$(element_0);
          var $this$frame = element_0;
          reactive($this$frame, VOID, ($this$reactive) => {
            var unit = $this$reactive.invoke_r7m7el_k$(unitChoice);
            $this$frame.clearChildren_eufjq4_k$();
            // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
            var this_0 = $this$frame;
            // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
            var this_1 = themed(this_0, FieldSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element = new (NumberInput())(this_1.get_context_h02k06_k$());
            ensureOutermostElement(element);
            this_1.willAddChild_hz2iwc_k$(element);
            element.set_align_ypalx0_k$(Align_End_getInstance());
            var tmp = (it) => unit.fromBase_1(it);
            element.bind_gesskf_k$(element.content_1, value.lens_u4wb4z_k$(tmp, (old, new_0) => !(new_0 == null) ? unit.toBase_1(new_0) : old));
            element.onStartup_vrxh3i_k$();
            this_1.addChild_2qpft2_k$(element);
            return element;
          });
          element_0.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          var this_1 = themed(element, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Select())(this_1.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_1.willAddChild_hz2iwc_k$(element_1);
          element_1.bind_64a41i_k$(unitChoice, new (Constant())(unitOptions), NumericValueClassRenderer$form$lambda$lambda);
          element_1.onStartup_vrxh3i_k$();
          this_1.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var v = $this$invoke.invoke_r7m7el_k$(value);
            var unit = this.pickUnit_sob447_k$(v);
            return this.format_rk25g1_k$(unit.fromBase_1(v)) + ' ' + unit.symbol_1;
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return 16.0;
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).cellForm_4mayde_k$ = cellForm;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForClass($, 'NumericValueClassRenderer', VOID, VOID, [Renderer()]);
    NumericValueClassRendererClass = $;
  }
  return NumericValueClassRendererClass;
}
function pickByMagnitude(value, units) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  if (units.get_size_woubt6_k$() === 1)
    return first(units);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(units, 10));
  var _iterator__ex2g4s = units.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    // Inline function 'kotlin.math.abs' call
    var x = item.fromBase_1(value);
    var tmp$ret$3 = Math.abs(x);
    var tmp$ret$2 = to(item, tmp$ret$3);
    destination.add_utx5q5_k$(tmp$ret$2);
  }
  var candidates = destination;
  var tmp$ret$4;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(candidates, Collection())) {
      tmp = candidates.isEmpty_y1axqb_k$();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$4 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s_0 = candidates.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s_0.next_20eer_k$();
      if (!(element.second_1 < 1.0E-12)) {
        tmp$ret$4 = false;
        break $l$block_0;
      }
    }
    tmp$ret$4 = true;
  }
  if (tmp$ret$4)
    return first(units);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s_1 = candidates.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
    var element_0 = _iterator__ex2g4s_1.next_20eer_k$();
    if (element_0.second_1 >= 1.0) {
      destination_0.add_utx5q5_k$(element_0);
    }
  }
  var tmp$ret$9;
  $l$block_2: {
    // Inline function 'kotlin.collections.minByOrNull' call
    var iterator = destination_0.iterator_jk1svi_k$();
    if (!iterator.hasNext_bitz1p_k$()) {
      tmp$ret$9 = null;
      break $l$block_2;
    }
    var minElem = iterator.next_20eer_k$();
    if (!iterator.hasNext_bitz1p_k$()) {
      tmp$ret$9 = minElem;
      break $l$block_2;
    }
    var minValue = minElem.second_1;
    do {
      var e = iterator.next_20eer_k$();
      var v = e.second_1;
      if (compareTo(minValue, v) > 0) {
        minElem = e;
        minValue = v;
      }
    }
     while (iterator.hasNext_bitz1p_k$());
    tmp$ret$9 = minElem;
  }
  var tmp0_safe_receiver = tmp$ret$9;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return tmp0_safe_receiver.first_1;
  }
  var tmp$ret$14;
  $l$block_3: {
    // Inline function 'kotlin.collections.maxBy' call
    var iterator_0 = candidates.iterator_jk1svi_k$();
    if (!iterator_0.hasNext_bitz1p_k$())
      throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
    var maxElem = iterator_0.next_20eer_k$();
    if (!iterator_0.hasNext_bitz1p_k$()) {
      tmp$ret$14 = maxElem;
      break $l$block_3;
    }
    var maxValue = maxElem.second_1;
    do {
      var e_0 = iterator_0.next_20eer_k$();
      var v_0 = e_0.second_1;
      if (compareTo(maxValue, v_0) < 0) {
        maxElem = e_0;
        maxValue = v_0;
      }
    }
     while (iterator_0.hasNext_bitz1p_k$());
    tmp$ret$14 = maxElem;
  }
  return tmp$ret$14.first_1;
}
function toSignificantDigits(_this__u8e3s4, digits) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  if (!isFinite(_this__u8e3s4) || _this__u8e3s4 === 0.0)
    return _this__u8e3s4;
  // Inline function 'kotlin.math.abs' call
  // Inline function 'kotlin.math.log10' call
  var x = Math.abs(_this__u8e3s4);
  // Inline function 'kotlin.math.floor' call
  var x_0 = log10(x);
  var tmp$ret$2 = Math.floor(x_0);
  var magnitude = numberToInt(tmp$ret$2);
  // Inline function 'kotlin.math.pow' call
  var x_1 = (digits - 1 | 0) - magnitude | 0;
  var scale = Math.pow(10.0, x_1);
  return round(_this__u8e3s4 * scale) / scale;
}
function dataSizeBinaryUnits$lambda(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return toNumber(_DataSize___get_bytes__impl__nlgkc0(it.bytes_1));
}
function dataSizeBinaryUnits$lambda_0(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (DataSize())(_DataSize___init__impl__iz9cfq(numberToLong(it)));
}
function dataSizeBinaryUnits$lambda_1(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _DataSize___get_kibibytes__impl__da5jmd(it.bytes_1);
}
function dataSizeBinaryUnits$lambda_2(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (DataSize())(_DataSize___init__impl__iz9cfq(numberToLong(it * 1024.0)));
}
function dataSizeBinaryUnits$lambda_3(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _DataSize___get_mebibytes__impl__wavpgx(it.bytes_1);
}
function dataSizeBinaryUnits$lambda_4(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (DataSize())(_DataSize___init__impl__iz9cfq(numberToLong(it * 1024.0 * 1024.0)));
}
function dataSizeBinaryUnits$lambda_5(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _DataSize___get_gibibytes__impl__nz4fl3(it.bytes_1);
}
function dataSizeBinaryUnits$lambda_6(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (DataSize())(_DataSize___init__impl__iz9cfq(numberToLong(it * 1024.0 * 1024.0 * 1024.0)));
}
function dataSizeBinaryUnits$lambda_7(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _DataSize___get_tebibytes__impl__kdhac8(it.bytes_1);
}
function dataSizeBinaryUnits$lambda_8(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (DataSize())(_DataSize___init__impl__iz9cfq(numberToLong(it * 1024.0 * 1024.0 * 1024.0 * 1024.0)));
}
function dataSizeDecimalUnits$lambda(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _DataSize___get_decimalKilobytes__impl__rjupzq(it.bytes_1);
}
function dataSizeDecimalUnits$lambda_0(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (DataSize())(_DataSize___init__impl__iz9cfq(numberToLong(it * 1000.0)));
}
function dataSizeDecimalUnits$lambda_1(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _DataSize___get_decimalMegabytes__impl__yffmh1(it.bytes_1);
}
function dataSizeDecimalUnits$lambda_2(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (DataSize())(_DataSize___init__impl__iz9cfq(numberToLong(it * 1000000.0)));
}
function dataSizeDecimalUnits$lambda_3(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _DataSize___get_decimalGigabytes__impl__q3ocl7(it.bytes_1);
}
function dataSizeDecimalUnits$lambda_4(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (DataSize())(_DataSize___init__impl__iz9cfq(numberToLong(it * 1.0E9)));
}
function dataSizeDecimalUnits$lambda_5(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _DataSize___get_decimalTerabytes__impl__rl89rd(it.bytes_1);
}
function dataSizeDecimalUnits$lambda_6(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (DataSize())(_DataSize___init__impl__iz9cfq(numberToLong(it * 1.0E12)));
}
function lengthMetricUnits$lambda(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Length___get_nanometer__impl__86nsy3(it.meters_1);
}
function lengthMetricUnits$lambda_0(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Length())(_Length___init__impl__mrryhn(it * 1.0E-9));
}
function lengthMetricUnits$lambda_1(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Length___get_micrometer__impl__xab82h(it.meters_1);
}
function lengthMetricUnits$lambda_2(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Length())(_Length___init__impl__mrryhn(it * 1.0E-6));
}
function lengthMetricUnits$lambda_3(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Length___get_millimeter__impl__i75bku(it.meters_1);
}
function lengthMetricUnits$lambda_4(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Length())(_Length___init__impl__mrryhn(it * 0.001));
}
function lengthMetricUnits$lambda_5(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Length___get_centimeters__impl__ltzset(it.meters_1);
}
function lengthMetricUnits$lambda_6(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Length())(_Length___init__impl__mrryhn(it * 0.01));
}
function lengthMetricUnits$lambda_7(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Length___get_meters__impl__co03t8(it.meters_1);
}
function lengthMetricUnits$lambda_8(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Length())(_Length___init__impl__mrryhn(it));
}
function lengthMetricUnits$lambda_9(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Length___get_kilometers__impl__syiikt(it.meters_1);
}
function lengthMetricUnits$lambda_10(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Length())(_Length___init__impl__mrryhn(it * 1000.0));
}
function lengthImperialUnits$lambda(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Length___get_inches__impl__de09ru(it.meters_1);
}
function lengthImperialUnits$lambda_0(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Length())(_Length___init__impl__mrryhn(it * 0.0254));
}
function lengthImperialUnits$lambda_1(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Length___get_feet__impl__kw6lw0(it.meters_1);
}
function lengthImperialUnits$lambda_2(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Length())(_Length___init__impl__mrryhn(it * 0.3048));
}
function lengthImperialUnits$lambda_3(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Length___get_yards__impl__8j9pnr(it.meters_1);
}
function lengthImperialUnits$lambda_4(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Length())(_Length___init__impl__mrryhn(it * 0.9144));
}
function lengthImperialUnits$lambda_5(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Length___get_miles__impl__iwi6te(it.meters_1);
}
function lengthImperialUnits$lambda_6(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Length())(_Length___init__impl__mrryhn(it * 1609.344));
}
function lengthMetricPreferred$lambda(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Length___get_meters__impl__co03t8(it.meters_1);
}
function lengthMetricPreferred$lambda_0(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Length())(_Length___init__impl__mrryhn(it));
}
function lengthMetricPreferred$lambda_1(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Length___get_millimeter__impl__i75bku(it.meters_1);
}
function lengthMetricPreferred$lambda_2(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Length())(_Length___init__impl__mrryhn(it * 0.001));
}
function lengthMetricPreferred$lambda_3(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Length___get_centimeters__impl__ltzset(it.meters_1);
}
function lengthMetricPreferred$lambda_4(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Length())(_Length___init__impl__mrryhn(it * 0.01));
}
function lengthMetricPreferred$lambda_5(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Length___get_micrometer__impl__xab82h(it.meters_1);
}
function lengthMetricPreferred$lambda_6(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Length())(_Length___init__impl__mrryhn(it * 1.0E-6));
}
function lengthMetricPreferred$lambda_7(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Length___get_nanometer__impl__86nsy3(it.meters_1);
}
function lengthMetricPreferred$lambda_8(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Length())(_Length___init__impl__mrryhn(it * 1.0E-9));
}
function lengthMetricPreferred$lambda_9(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Length___get_kilometers__impl__syiikt(it.meters_1);
}
function lengthMetricPreferred$lambda_10(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Length())(_Length___init__impl__mrryhn(it * 1000.0));
}
function areaMetricUnits$lambda(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Area___get_squareMillimeters__impl__fkxnwh(it.squareMeters_1);
}
function areaMetricUnits$lambda_0(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Area())(_Area___init__impl__ijsx70(it * 1.0E-6));
}
function areaMetricUnits$lambda_1(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Area___get_squareCentimeters__impl__t9odvv(it.squareMeters_1);
}
function areaMetricUnits$lambda_2(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Area())(_Area___init__impl__ijsx70(it * 1.0E-4));
}
function areaMetricUnits$lambda_3(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Area___get_squareMeters__impl__tdkp4u(it.squareMeters_1);
}
function areaMetricUnits$lambda_4(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Area())(_Area___init__impl__ijsx70(it));
}
function areaMetricUnits$lambda_5(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Area___get_hectare__impl__ftwe8j(it.squareMeters_1);
}
function areaMetricUnits$lambda_6(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Area())(_Area___init__impl__ijsx70(it * 10000.0));
}
function areaMetricUnits$lambda_7(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Area___get_squareKilometers__impl__3iiltv(it.squareMeters_1);
}
function areaMetricUnits$lambda_8(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Area())(_Area___init__impl__ijsx70(it * 1000000.0));
}
function areaMetricPreferred$lambda(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Area___get_squareMeters__impl__tdkp4u(it.squareMeters_1);
}
function areaMetricPreferred$lambda_0(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Area())(_Area___init__impl__ijsx70(it));
}
function areaMetricPreferred$lambda_1(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Area___get_squareCentimeters__impl__t9odvv(it.squareMeters_1);
}
function areaMetricPreferred$lambda_2(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Area())(_Area___init__impl__ijsx70(it * 1.0E-4));
}
function areaMetricPreferred$lambda_3(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Area___get_squareMillimeters__impl__fkxnwh(it.squareMeters_1);
}
function areaMetricPreferred$lambda_4(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Area())(_Area___init__impl__ijsx70(it * 1.0E-6));
}
function areaMetricPreferred$lambda_5(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Area___get_hectare__impl__ftwe8j(it.squareMeters_1);
}
function areaMetricPreferred$lambda_6(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Area())(_Area___init__impl__ijsx70(it * 10000.0));
}
function areaMetricPreferred$lambda_7(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Area___get_squareKilometers__impl__3iiltv(it.squareMeters_1);
}
function areaMetricPreferred$lambda_8(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Area())(_Area___init__impl__ijsx70(it * 1000000.0));
}
function volumeMetricUnits$lambda(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Volume___get_milliliters__impl__2fzycw(it.cubicMeters_1);
}
function volumeMetricUnits$lambda_0(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Volume())(_Volume___init__impl__tjrqop(it * 1.0E-6));
}
function volumeMetricUnits$lambda_1(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Volume___get_liters__impl__yw6tct(it.cubicMeters_1);
}
function volumeMetricUnits$lambda_2(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Volume())(_Volume___init__impl__tjrqop(it * 0.001));
}
function volumeMetricUnits$lambda_3(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Volume___get_cubicMeters__impl__6kaaeg(it.cubicMeters_1);
}
function volumeMetricUnits$lambda_4(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Volume())(_Volume___init__impl__tjrqop(it));
}
function volumeMetricPreferred$lambda(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Volume___get_cubicMeters__impl__6kaaeg(it.cubicMeters_1);
}
function volumeMetricPreferred$lambda_0(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Volume())(_Volume___init__impl__tjrqop(it));
}
function volumeMetricPreferred$lambda_1(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Volume___get_liters__impl__yw6tct(it.cubicMeters_1);
}
function volumeMetricPreferred$lambda_2(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Volume())(_Volume___init__impl__tjrqop(it * 0.001));
}
function volumeMetricPreferred$lambda_3(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Volume___get_milliliters__impl__2fzycw(it.cubicMeters_1);
}
function volumeMetricPreferred$lambda_4(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Volume())(_Volume___init__impl__tjrqop(it * 1.0E-6));
}
function massMetricUnits$lambda(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Mass___get_milligrams__impl__s8wiar(it.kilograms_1);
}
function massMetricUnits$lambda_0(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Mass())(_Mass___init__impl__g55pzh(it * 1.0E-6));
}
function massMetricUnits$lambda_1(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Mass___get_grams__impl__rxyb9m(it.kilograms_1);
}
function massMetricUnits$lambda_2(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Mass())(_Mass___init__impl__g55pzh(it * 0.001));
}
function massMetricUnits$lambda_3(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Mass___get_kilograms__impl__lr3pd5(it.kilograms_1);
}
function massMetricUnits$lambda_4(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Mass())(_Mass___init__impl__g55pzh(it));
}
function massMetricUnits$lambda_5(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Mass___get_tonnes__impl__aj2kxp(it.kilograms_1);
}
function massMetricUnits$lambda_6(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Mass())(_Mass___init__impl__g55pzh(it * 1000.0));
}
function massMetricPreferred$lambda(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Mass___get_kilograms__impl__lr3pd5(it.kilograms_1);
}
function massMetricPreferred$lambda_0(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Mass())(_Mass___init__impl__g55pzh(it));
}
function massMetricPreferred$lambda_1(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Mass___get_grams__impl__rxyb9m(it.kilograms_1);
}
function massMetricPreferred$lambda_2(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Mass())(_Mass___init__impl__g55pzh(it * 0.001));
}
function massMetricPreferred$lambda_3(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Mass___get_milligrams__impl__s8wiar(it.kilograms_1);
}
function massMetricPreferred$lambda_4(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Mass())(_Mass___init__impl__g55pzh(it * 1.0E-6));
}
function massMetricPreferred$lambda_5(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Mass___get_tonnes__impl__aj2kxp(it.kilograms_1);
}
function massMetricPreferred$lambda_6(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Mass())(_Mass___init__impl__g55pzh(it * 1000.0));
}
function speedMetricUnits$lambda(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Speed___get_metersPerSecond__impl__t1zksw(it.metersPerSecond_1);
}
function speedMetricUnits$lambda_0(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Speed())(_Speed___init__impl__580hla(it));
}
function speedMetricUnits$lambda_1(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Speed___get_kilometersPerHour__impl__2ucvcx(it.metersPerSecond_1);
}
function speedMetricUnits$lambda_2(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Speed())(_Speed___init__impl__580hla(it * 0.2777777777777778));
}
function accelerationMetricUnits$lambda(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Acceleration___get_metersPerSecondPerSecond__impl__3zde26(it.metersPerSecondPerSecond_1);
}
function accelerationMetricUnits$lambda_0(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Acceleration())(_Acceleration___init__impl__lpurpb(it));
}
function accelerationMetricUnits$lambda_1(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Acceleration___get_kilometersPerHourPerSecond__impl__toxtnn(it.metersPerSecondPerSecond_1);
}
function accelerationMetricUnits$lambda_2(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Acceleration())(_Acceleration___init__impl__lpurpb(it * 0.2777777777777778));
}
function pressureMetricUnits$lambda(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Pressure___get_pascals__impl__m59t3u(it.pascals_1);
}
function pressureMetricUnits$lambda_0(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Pressure())(_Pressure___init__impl__4rek04(it));
}
function pressureMetricUnits$lambda_1(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Pressure___get_millibars__impl__we5tn8(it.pascals_1);
}
function pressureMetricUnits$lambda_2(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Pressure())(_Pressure___init__impl__4rek04(it * 100.0));
}
function pressureMetricUnits$lambda_3(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Pressure___get_pascals__impl__m59t3u(it.pascals_1) / 1000.0;
}
function pressureMetricUnits$lambda_4(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Pressure())(_Pressure___init__impl__4rek04(it * 1000.0));
}
function pressureMetricUnits$lambda_5(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Pressure___get_bars__impl__4r7a77(it.pascals_1);
}
function pressureMetricUnits$lambda_6(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Pressure())(_Pressure___init__impl__4rek04(it * 100000.0));
}
function energyMetricUnits$lambda(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Energy___get_joules__impl__q784q(it.joules_1);
}
function energyMetricUnits$lambda_0(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Energy())(_Energy___init__impl__paow1l(it));
}
function energyMetricUnits$lambda_1(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Energy___get_joules__impl__q784q(it.joules_1) / 1000.0;
}
function energyMetricUnits$lambda_2(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Energy())(_Energy___init__impl__paow1l(it * 1000.0));
}
function energyMetricUnits$lambda_3(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return _Energy___get_joules__impl__q784q(it.joules_1) / 1000000.0;
}
function energyMetricUnits$lambda_4(it) {
  _init_properties_SpecialTypeRenderers_kt__yq1t7n();
  return new (Energy())(_Energy___init__impl__paow1l(it * 1000000.0));
}
var properties_initialized_SpecialTypeRenderers_kt_5adsv5;
function _init_properties_SpecialTypeRenderers_kt__yq1t7n() {
  if (!properties_initialized_SpecialTypeRenderers_kt_5adsv5) {
    properties_initialized_SpecialTypeRenderers_kt_5adsv5 = true;
    var tmp = dataSizeBinaryUnits$lambda;
    var tmp_0 = new (ValueUnit())('B', tmp, dataSizeBinaryUnits$lambda_0);
    var tmp_1 = dataSizeBinaryUnits$lambda_1;
    var tmp_2 = new (ValueUnit())('KiB', tmp_1, dataSizeBinaryUnits$lambda_2);
    var tmp_3 = dataSizeBinaryUnits$lambda_3;
    var tmp_4 = new (ValueUnit())('MiB', tmp_3, dataSizeBinaryUnits$lambda_4);
    var tmp_5 = dataSizeBinaryUnits$lambda_5;
    var tmp_6 = new (ValueUnit())('GiB', tmp_5, dataSizeBinaryUnits$lambda_6);
    var tmp_7 = dataSizeBinaryUnits$lambda_7;
    dataSizeBinaryUnits = listOf([tmp_0, tmp_2, tmp_4, tmp_6, new (ValueUnit())('TiB', tmp_7, dataSizeBinaryUnits$lambda_8)]);
    var tmp_8 = dataSizeDecimalUnits$lambda;
    var tmp_9 = new (ValueUnit())('KB', tmp_8, dataSizeDecimalUnits$lambda_0);
    var tmp_10 = dataSizeDecimalUnits$lambda_1;
    var tmp_11 = new (ValueUnit())('MB', tmp_10, dataSizeDecimalUnits$lambda_2);
    var tmp_12 = dataSizeDecimalUnits$lambda_3;
    var tmp_13 = new (ValueUnit())('GB', tmp_12, dataSizeDecimalUnits$lambda_4);
    var tmp_14 = dataSizeDecimalUnits$lambda_5;
    dataSizeDecimalUnits = listOf([tmp_9, tmp_11, tmp_13, new (ValueUnit())('TB', tmp_14, dataSizeDecimalUnits$lambda_6)]);
    var tmp_15 = lengthMetricUnits$lambda;
    var tmp_16 = new (ValueUnit())('nm', tmp_15, lengthMetricUnits$lambda_0);
    var tmp_17 = lengthMetricUnits$lambda_1;
    var tmp_18 = new (ValueUnit())('\u03BCm', tmp_17, lengthMetricUnits$lambda_2);
    var tmp_19 = lengthMetricUnits$lambda_3;
    var tmp_20 = new (ValueUnit())('mm', tmp_19, lengthMetricUnits$lambda_4);
    var tmp_21 = lengthMetricUnits$lambda_5;
    var tmp_22 = new (ValueUnit())('cm', tmp_21, lengthMetricUnits$lambda_6);
    var tmp_23 = lengthMetricUnits$lambda_7;
    var tmp_24 = new (ValueUnit())('m', tmp_23, lengthMetricUnits$lambda_8);
    var tmp_25 = lengthMetricUnits$lambda_9;
    lengthMetricUnits = listOf([tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, new (ValueUnit())('km', tmp_25, lengthMetricUnits$lambda_10)]);
    var tmp_26 = lengthImperialUnits$lambda;
    var tmp_27 = new (ValueUnit())('in', tmp_26, lengthImperialUnits$lambda_0);
    var tmp_28 = lengthImperialUnits$lambda_1;
    var tmp_29 = new (ValueUnit())('ft', tmp_28, lengthImperialUnits$lambda_2);
    var tmp_30 = lengthImperialUnits$lambda_3;
    var tmp_31 = new (ValueUnit())('yd', tmp_30, lengthImperialUnits$lambda_4);
    var tmp_32 = lengthImperialUnits$lambda_5;
    lengthImperialUnits = listOf([tmp_27, tmp_29, tmp_31, new (ValueUnit())('mi', tmp_32, lengthImperialUnits$lambda_6)]);
    var tmp_33 = lengthMetricPreferred$lambda;
    var tmp_34 = new (ValueUnit())('m', tmp_33, lengthMetricPreferred$lambda_0);
    var tmp_35 = lengthMetricPreferred$lambda_1;
    var tmp_36 = new (ValueUnit())('mm', tmp_35, lengthMetricPreferred$lambda_2);
    var tmp_37 = lengthMetricPreferred$lambda_3;
    var tmp_38 = new (ValueUnit())('cm', tmp_37, lengthMetricPreferred$lambda_4);
    var tmp_39 = lengthMetricPreferred$lambda_5;
    var tmp_40 = new (ValueUnit())('\u03BCm', tmp_39, lengthMetricPreferred$lambda_6);
    var tmp_41 = lengthMetricPreferred$lambda_7;
    var tmp_42 = new (ValueUnit())('nm', tmp_41, lengthMetricPreferred$lambda_8);
    var tmp_43 = lengthMetricPreferred$lambda_9;
    lengthMetricPreferred = listOf([tmp_34, tmp_36, tmp_38, tmp_40, tmp_42, new (ValueUnit())('km', tmp_43, lengthMetricPreferred$lambda_10)]);
    var tmp_44 = areaMetricUnits$lambda;
    var tmp_45 = new (ValueUnit())('mm\xB2', tmp_44, areaMetricUnits$lambda_0);
    var tmp_46 = areaMetricUnits$lambda_1;
    var tmp_47 = new (ValueUnit())('cm\xB2', tmp_46, areaMetricUnits$lambda_2);
    var tmp_48 = areaMetricUnits$lambda_3;
    var tmp_49 = new (ValueUnit())('m\xB2', tmp_48, areaMetricUnits$lambda_4);
    var tmp_50 = areaMetricUnits$lambda_5;
    var tmp_51 = new (ValueUnit())('ha', tmp_50, areaMetricUnits$lambda_6);
    var tmp_52 = areaMetricUnits$lambda_7;
    areaMetricUnits = listOf([tmp_45, tmp_47, tmp_49, tmp_51, new (ValueUnit())('km\xB2', tmp_52, areaMetricUnits$lambda_8)]);
    var tmp_53 = areaMetricPreferred$lambda;
    var tmp_54 = new (ValueUnit())('m\xB2', tmp_53, areaMetricPreferred$lambda_0);
    var tmp_55 = areaMetricPreferred$lambda_1;
    var tmp_56 = new (ValueUnit())('cm\xB2', tmp_55, areaMetricPreferred$lambda_2);
    var tmp_57 = areaMetricPreferred$lambda_3;
    var tmp_58 = new (ValueUnit())('mm\xB2', tmp_57, areaMetricPreferred$lambda_4);
    var tmp_59 = areaMetricPreferred$lambda_5;
    var tmp_60 = new (ValueUnit())('ha', tmp_59, areaMetricPreferred$lambda_6);
    var tmp_61 = areaMetricPreferred$lambda_7;
    areaMetricPreferred = listOf([tmp_54, tmp_56, tmp_58, tmp_60, new (ValueUnit())('km\xB2', tmp_61, areaMetricPreferred$lambda_8)]);
    var tmp_62 = volumeMetricUnits$lambda;
    var tmp_63 = new (ValueUnit())('mL', tmp_62, volumeMetricUnits$lambda_0);
    var tmp_64 = volumeMetricUnits$lambda_1;
    var tmp_65 = new (ValueUnit())('L', tmp_64, volumeMetricUnits$lambda_2);
    var tmp_66 = volumeMetricUnits$lambda_3;
    volumeMetricUnits = listOf([tmp_63, tmp_65, new (ValueUnit())('m\xB3', tmp_66, volumeMetricUnits$lambda_4)]);
    var tmp_67 = volumeMetricPreferred$lambda;
    var tmp_68 = new (ValueUnit())('m\xB3', tmp_67, volumeMetricPreferred$lambda_0);
    var tmp_69 = volumeMetricPreferred$lambda_1;
    var tmp_70 = new (ValueUnit())('L', tmp_69, volumeMetricPreferred$lambda_2);
    var tmp_71 = volumeMetricPreferred$lambda_3;
    volumeMetricPreferred = listOf([tmp_68, tmp_70, new (ValueUnit())('mL', tmp_71, volumeMetricPreferred$lambda_4)]);
    var tmp_72 = massMetricUnits$lambda;
    var tmp_73 = new (ValueUnit())('mg', tmp_72, massMetricUnits$lambda_0);
    var tmp_74 = massMetricUnits$lambda_1;
    var tmp_75 = new (ValueUnit())('g', tmp_74, massMetricUnits$lambda_2);
    var tmp_76 = massMetricUnits$lambda_3;
    var tmp_77 = new (ValueUnit())('kg', tmp_76, massMetricUnits$lambda_4);
    var tmp_78 = massMetricUnits$lambda_5;
    massMetricUnits = listOf([tmp_73, tmp_75, tmp_77, new (ValueUnit())('t', tmp_78, massMetricUnits$lambda_6)]);
    var tmp_79 = massMetricPreferred$lambda;
    var tmp_80 = new (ValueUnit())('kg', tmp_79, massMetricPreferred$lambda_0);
    var tmp_81 = massMetricPreferred$lambda_1;
    var tmp_82 = new (ValueUnit())('g', tmp_81, massMetricPreferred$lambda_2);
    var tmp_83 = massMetricPreferred$lambda_3;
    var tmp_84 = new (ValueUnit())('mg', tmp_83, massMetricPreferred$lambda_4);
    var tmp_85 = massMetricPreferred$lambda_5;
    massMetricPreferred = listOf([tmp_80, tmp_82, tmp_84, new (ValueUnit())('t', tmp_85, massMetricPreferred$lambda_6)]);
    var tmp_86 = speedMetricUnits$lambda;
    var tmp_87 = new (ValueUnit())('m/s', tmp_86, speedMetricUnits$lambda_0);
    var tmp_88 = speedMetricUnits$lambda_1;
    speedMetricUnits = listOf([tmp_87, new (ValueUnit())('km/h', tmp_88, speedMetricUnits$lambda_2)]);
    var tmp_89 = accelerationMetricUnits$lambda;
    var tmp_90 = new (ValueUnit())('m/s\xB2', tmp_89, accelerationMetricUnits$lambda_0);
    var tmp_91 = accelerationMetricUnits$lambda_1;
    accelerationMetricUnits = listOf([tmp_90, new (ValueUnit())('km/h/s', tmp_91, accelerationMetricUnits$lambda_2)]);
    var tmp_92 = pressureMetricUnits$lambda;
    var tmp_93 = new (ValueUnit())('Pa', tmp_92, pressureMetricUnits$lambda_0);
    var tmp_94 = pressureMetricUnits$lambda_1;
    var tmp_95 = new (ValueUnit())('mbar', tmp_94, pressureMetricUnits$lambda_2);
    var tmp_96 = pressureMetricUnits$lambda_3;
    var tmp_97 = new (ValueUnit())('kPa', tmp_96, pressureMetricUnits$lambda_4);
    var tmp_98 = pressureMetricUnits$lambda_5;
    pressureMetricUnits = listOf([tmp_93, tmp_95, tmp_97, new (ValueUnit())('bar', tmp_98, pressureMetricUnits$lambda_6)]);
    var tmp_99 = energyMetricUnits$lambda;
    var tmp_100 = new (ValueUnit())('J', tmp_99, energyMetricUnits$lambda_0);
    var tmp_101 = energyMetricUnits$lambda_1;
    var tmp_102 = new (ValueUnit())('kJ', tmp_101, energyMetricUnits$lambda_2);
    var tmp_103 = energyMetricUnits$lambda_3;
    energyMetricUnits = listOf([tmp_100, tmp_102, new (ValueUnit())('MJ', tmp_103, energyMetricUnits$lambda_4)]);
  }
}
//region block: init
UuidRenderer_instance = new (UuidRenderer())();
EmailAddressRenderer_instance = new (EmailAddressRenderer())();
PhoneNumberRenderer_instance = new (PhoneNumberRenderer())();
GeoCoordinateRenderer_instance = new (GeoCoordinateRenderer())();
CentsRenderer_instance = new (CentsRenderer())();
//endregion
//region block: exports
export {
  registerSpecialTypes as registerSpecialTypes24867s8682369,
};
//endregion

//# sourceMappingURL=SpecialTypeRenderers.mjs.map
